export const babyCareData1 = [
    {
        id: 1,
        title: "ბავშვის კრემები",
        firstLogo: "/images/pharmacy/pharmaHouse/biolike.svg",
        secondLogo: "/images/pharmacy/pharmaHouse/freziDerm.svg",
        productImg: "/images/pharmacy/pharmaHouse/cream.svg",
    },
    {
        id: 2,
        title: "დასაბანი საშუალებები",
        firstLogo: "/images/pharmacy/pharmaHouse/biolike.svg",
        secondLogo: "/images/pharmacy/pharmaHouse/freziDerm.svg",
        productImg: "/images/pharmacy/pharmaHouse/bath.svg",
    },
    {
        id: 3,
        title: "სველი სალფეთქები",
        firstLogo: "/images/pharmacy/pharmaHouse/biolike.svg",
        secondLogo: "/images/pharmacy/pharmaHouse/tidoo.svg",
        productImg: "/images/pharmacy/pharmaHouse/napkin.svg",
    },
    {
        id: 4,
        title: "მზისგან დამცავი საშუალებები",
        firstLogo: "/images/pharmacy/pharmaHouse/biolike.svg",
        secondLogo: "/images/pharmacy/pharmaHouse/freziDerm.svg",
        productImg: "/images/pharmacy/pharmaHouse/cream.svg",
    },
    {
        id: 5,
        title: "საფენები და ტრუსები",
        firstLogo: "/images/pharmacy/pharmaHouse/tidoo.svg",
        secondLogo: "",
        productImg: "/images/pharmacy/pharmaHouse/Pampers.svg",
    },
    {
        id: 6,
        title: "ყურის ჩხირები",
        firstLogo: "/images/pharmacy/pharmaHouse/jeanCarol.svg",
        secondLogo: "",
        productImg: "/images/pharmacy/pharmaHouse/earsticks.svg",
    },
    {
        id: 7,
        title: "კბილის პასტები",
        firstLogo: "/images/pharmacy/pharmaHouse/freziDerm.svg",
        secondLogo: "",
        productImg: "/images/pharmacy/pharmaHouse/toothbrush.svg",
    },
]


export const daysList = [
    {
      day: "ორშაბათი",
      isVita: true,
      img: "/images/pharmacy/vita.svg",
    },
    {
      day: "სამშაბათი",
      isVita: false,
      img: "/images/pharmacy/pharmaHouse/pharmHouseLogo.svg",
    },
    {
      day: "ოთხშაბათი",
      isVita: false,
      img: "/images/pharmacy/pharmaHouse/pharmHouseLogo.svg",
    },
    {
      day: "ხუთშაბათი",
      isVita: true,
      img: "/images/pharmacy/vita.svg",
    },
    {
      day: "პარასკევი",
      isVita: false,
      img: "/images/pharmacy/pharmaHouse/pharmHouseLogo.svg",
    },
    {
      day: "შაბათი",
      isVita: true,
      img: "/images/pharmacy/vita.svg",
    },
    {
      day: "კვირა",
      isVita: true,
      img: "/images/pharmacy/vita.svg",
    },
  ];

  export const cardsList = [
    {
      id: 1,
      img: "/images/pharmacy/pharmaHouse/card1.png",
    },
    {
      id: 2,
      img: "/images/pharmacy/pharmaHouse/card2.png",
    },
    {
      id: 3,
      img: "/images/pharmacy/pharmaHouse/card3.png",
    },
    {
      id: 4,
      img: "/images/pharmacy/pharmaHouse/card4.png",
    },
    {
      id: 5,
      img: "/images/pharmacy/pharmaHouse/card5.png",
    },
  ];


export const medicalTechnicsData = [
    {
        id: 1,
        title: "სასწორები",
        img: "/images/pharmacy/pharmaHouse/scale.svg",
    },
    {
        id: 2,
        title: "თერმომეტრები",
        img: "/images/pharmacy/pharmaHouse/techniques.svg",
    },
    {
        id: 3,
        title: "წნევის აპარატები ფონეიდოსკოპები",
        img: "/images/pharmacy/pharmaHouse/technique2.svg",
    },
    {
        id: 4,
        title: "ნებულაიზერები",
        img: "/images/pharmacy/pharmaHouse/technique1.svg",
    },
    {
        id: 5,
        title: "ირიგატორები",
        img: "/images/pharmacy/pharmaHouse/toothbrushes.svg",
    },
]

export const cosmeticsData = [
  {
    id: 1,
    text1: "თვალის კორექტორი",
    text2: "ზეთი",
    text3: "ფანქარი",
    img: "/images/pharmacy/pharmaHouse/cosmetic1.svg"
  },
  {
    id: 2,
    text1: "წარბის კორექტორი",
    text2: "ზეთი",
    text3: "ფანქარი",
    img: "/images/pharmacy/pharmaHouse/cosmetic2.svg"
  },
  {
    id: 3,
    text1: "თვალის ჩრდილები",
    text2: "",
    text3: "",
    img: "/images/pharmacy/pharmaHouse/cosmetic3.svg"
  },
  {
    id: 4,
    text1: "რუმინა",
    text2: "ბლაშები",
    text3: "პუდრა",
    img: "/images/pharmacy/pharmaHouse/cosmetic4.svg"
  },
  {
    id: 5,
    text1: "პომადა",
    text2: "კონტური",
    text3: "ბალმი",
    img: "/images/pharmacy/pharmaHouse/cosmetic5.svg"
  },
  {
    id: 6,
    text1: "ტუში",
    text2: "ლაინერი",
    text3: "",
    img: "/images/pharmacy/pharmaHouse/cosmetic6.svg"
  },
  {
    id: 7,
    text1: "მაკიაჟის აქსესუარები",
    text2: "",
    text3: "",
    img: "/images/pharmacy/pharmaHouse/cosmetic7.svg"
  },
  {
    id: 8,
    text1: "ქალის სუნამოები",
    text2: "",
    text3: "",
    img: "/images/pharmacy/pharmaHouse/cosmetic8.svg"
  },
  {
    id: 9,
    text1: "სასაჩუქრე ნაკრები",
    text2: "",
    text3: "",
    img: "/images/pharmacy/pharmaHouse/cosmetic9.svg"
  },
  {
    id: 10,
    text1: "ტონალური და",
    text2: "BB კრემი",
    text3: "",
    img: "/images/pharmacy/pharmaHouse/cosmetic10.svg"
  },
  {
    id: 11,
    text1: "პრაიმერები და",
    text2: "კონსილერები",
    text3: "",
    img: "/images/pharmacy/pharmaHouse/cosmetic11.svg"
  },
]

export const medicineCardsData = [
  {
    id: 1,
    title: "ლეიკოები/პლასტირები",
    img: "/images/pharmacy/pharmaHouse/sos.svg"
  },
    {
    id: 2,
    title: "პარაზიტების საწინააღმდეგო საშუალებები",
    img: "/images/pharmacy/pharmaHouse/frezyderm1.svg"
  },
  {
    id: 3,
    title: "პროტოზოული საშუალებები",
    img: "/images/pharmacy/pharmaHouse/sos.svg"
  },
  {
    id: 4,
    title: "კრემები და გელები",
    img: "/images/pharmacy/pharmaHouse/sos.svg"
  }
]

export const hygieneProductsData = [
  {
    id: 1,
    title: "ინტიმური მოვლის საშუალებები",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "/images/pharmacy/pharmaHouse/freziDerm.svg",
    img3: "",
    img4: "",
  },
  {
    id: 2,
    title: "ჰიგიენური პაკეტები",
    img1: "/images/pharmacy/pharmaHouse/tadam.svg",
    img2: "/images/pharmacy/pharmaHouse/cosmea.svg",
    img3: "",
    img4: "",
  },
  {
    id: 3,
    title: "ყოველდღიური პაკეტები",
    img1: "/images/pharmacy/pharmaHouse/tadam.svg",
    img2: "",
    img3: "",
    img4: "",
  },
  {
    id: 4,
    title: "ჰიგიენური ტამპონები",
    img1: "/images/pharmacy/pharmaHouse/tadam.svg",
    img2: "/images/pharmacy/pharmaHouse/cosmea.svg",
    img3: "",
    img4: "",
  },
  {
    id: 5,
    title: "მწოლიარესსაფენი/ზეწარი/ტრუსები",
    img1: "/images/pharmacy/pharmaHouse/tadam.svg",
    img2: "",
    img3: "",
    img4: "",
  },
  {
    id: 6,
    title: "ბამბის დისკები",
    img1: "/images/pharmacy/pharmaHouse/tadam.svg",
    img2: "",
    img3: "/images/pharmacy/pharmaHouse/jeanCarol.svg",
    img4: "/images/pharmacy/pharmaHouse/cosmea.svg",
  },
  {
    id: 7,
    title: "ფეხის კრემები",
    img1: "/images/pharmacy/pharmaHouse/hauschka.svg",
    img2: "/images/pharmacy/pharmaHouse/florinda.svg",
    img3: "",
    img4: "",
  },
  {
    id: 8,
    title: "ბავშვის სველი სალფეთქები, ტრუსები და საფენები",
    img1: "/images/pharmacy/pharmaHouse/tidoo.svg",
    img2: "/images/pharmacy/pharmaHouse/biolike.svg",
    img3: "",
    img4: "",
  },
  {
    id: 9,
    title: "ბავშვის დასაბანი საშუალებები",
    img1: "/images/pharmacy/pharmaHouse/freziDerm.svg",
    img2: "/images/pharmacy/pharmaHouse/tidoo.svg",
    img3: "/images/pharmacy/pharmaHouse/biolike.svg",
    img4: "/images/pharmacy/pharmaHouse/dermina.svg",
  },
  {
    id: 10,
    title: "მეძუძური დედის მოვლა",
    img1: "/images/pharmacy/pharmaHouse/jeanCarol.svg",
    img2: "/images/pharmacy/pharmaHouse/cosmea.svg",
    img3: "",
    img4: "",
  },
  {
    id: 11,
    title: "ზრდასრულის და ბავშვის ყურის ჩხირები",
    img1: "/images/pharmacy/pharmaHouse/jeanCarol.svg",
    img2: "",
    img3: "",
    img4: "",
  },
  {
    id: 12,
    title: "ნატურალური საპნები",
    img1: "/images/pharmacy/pharmaHouse/florinda.svg",
    img2: "",
    img3: "",
    img4: "",
  },
  {
    id: 13,
    title: "მამაკაცის ჰიგიენური საშუალებები",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "",
    img3: "",
    img4: "",
  },
  {
    id: 14,
    title: "დეოდორანტები",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "",
    img3: "",
    img4: "",
  },
]

export const bodyCareProducts = [
  {
    id: 1,
    title1: "შხაპის გელები",
    title2: "სკრაბები",
    title3: "საპნები",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "/images/pharmacy/pharmaHouse/florinda.svg",
    img3: ""
  },
  {
    id: 2,
    title1: "ტანის კრემი",
    title2: "ბალზამები",
    title3: "",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "/images/pharmacy/pharmaHouse/hauschka.svg",
    img3: "/images/pharmacy/pharmaHouse/florinda.svg"
  },
  {
    id: 3,
    title1: "ფეხის კრემები",
    title2: "",
    title3: "",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "/images/pharmacy/pharmaHouse/hauschka.svg",
    img3: "/images/pharmacy/pharmaHouse/florinda.svg"
  },
  {
    id: 4,
    title1: "ხელის კრემები",
    title2: "",
    title3: "",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "",
    img3: ""
  },
  {
    id: 5,
    title1: "ტანის ზეთები",
    title2: "სამასაჟო სტრიებისა და",
    title3: "ანტიცელულიტური ზეთები",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "/images/pharmacy/pharmaHouse/hauschka.svg",
    img3: "/images/pharmacy/pharmaHouse/florinda.svg"
  },
  {
    id: 6,
    title1: "ბავშვის დასაბანი",
    title2: "საშუალებები",
    title3: "",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "/images/pharmacy/pharmaHouse/florinda.svg",
    img3: ""
  },
  {
    id: 7,
    title1: "მზისგან დამცავი",
    title2: "საშუალებები",
    title3: "",
    img1: "/images/pharmacy/pharmaHouse/biolike.svg",
    img2: "/images/pharmacy/pharmaHouse/freziDerm.svg",
    img3: ""
  },
]


export const faceCareData = [
  {
    id: 1,
    text: "სახის საცხები",
    children: {
      parentId: 1,
      text: "მუდმივმოქმედი,  35% ფასდაკლება მოცემული  ბრენდების ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველ დღე და ულიმიტოდ.",
      img1: "/images/pharmacy/pharmaHouse/biolike.svg",
      img2: "/images/pharmacy/pharmaHouse/dermina.svg",
      img3: "/images/pharmacy/pharmaHouse/saeve.svg",
      img4: "/images/pharmacy/pharmaHouse/hauschka.svg",
      img5: "/images/pharmacy/pharmaHouse/freziDerm.svg",
    }
  },
  {
    id: 2,
    text: "შრატები/ლოსიონები/ტონერები",
    children: {
      parentId: 2,
      text: "მუდმივმოქმედი,  35% ფასდაკლება მოცემული  ბრენდების ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველ დღე და ულიმიტოდ.",
      img1: "/images/pharmacy/pharmaHouse/biolike.svg",
      img2: "/images/pharmacy/pharmaHouse/dermina.svg",
      img3: "/images/pharmacy/pharmaHouse/saeve.svg",
      img4: "/images/pharmacy/pharmaHouse/hauschka.svg",
      img5: "/images/pharmacy/pharmaHouse/freziDerm.svg",
    }
  },
  {
    id: 3,
    text: "ნიღბები და პაჩები",
    children: {
      parentId: 3,
      text: "მუდმივმოქმედი,  35% ფასდაკლება მოცემული  ბრენდების ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველ დღე და ულიმიტოდ.",
      img1: "/images/pharmacy/pharmaHouse/freziDerm.svg",
      img2: "/images/pharmacy/pharmaHouse/biolike.svg",
      img3: "/images/pharmacy/pharmaHouse/hauschka.svg",
      img4: "/images/pharmacy/pharmaHouse/saeve.svg",
      img5: "/images/pharmacy/pharmaHouse/ecosecret.svg",
    }
  },
  {
    id: 4,
    text: "აკნესა და ლაქების სამკურნალო",
    children: {
      parentId: 4,
      text: "მუდმივმოქმედი,  35% ფასდაკლება მოცემული  ბრენდების ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველ დღე და ულიმიტოდ.",
      img1: "/images/pharmacy/pharmaHouse/biolike.svg",
      img2: "/images/pharmacy/pharmaHouse/freziDerm.svg",
      img3: "/images/pharmacy/pharmaHouse/dermina.svg",
      img4: "",
      img5: "",
    }
  },
  {
    id: 5,
    text: "მზისგან დამცავი",
    children: {
      parentId: 5,
      text: "მუდმივმოქმედი,  35% ფასდაკლება მოცემული  ბრენდების ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველ დღე და ულიმიტოდ.",
      img1: "/images/pharmacy/pharmaHouse/freziDerm.svg",
      img2: "/images/pharmacy/pharmaHouse/biolike.svg",
      img3: "/images/pharmacy/pharmaHouse/dermina.svg",
      img4: "",
      img5: "",
    }
  },
  {
    id: 6,
    text: "დასაბანი და გამწმენდი",
    children: {
      parentId: 6,
      text: "მუდმივმოქმედი,  35% ფასდაკლება მოცემული  ბრენდების ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველ დღე და ულიმიტოდ.",
      img1: "/images/pharmacy/pharmaHouse/biolike.svg",
      img2: "/images/pharmacy/pharmaHouse/dermina.svg",
      img3: "/images/pharmacy/pharmaHouse/saeve.svg",
      img4: "/images/pharmacy/pharmaHouse/hauschka.svg",
      img5: "/images/pharmacy/pharmaHouse/freziDerm.svg",
    }
  },
]